<template>
  <div class="home">
      <div class="home-logo">
        <img :src="siteData.urlLogo" :style="siteData.stylesLogo">
      </div>

      <h1>
        {{ $t('home.title', { name: siteData.legalName }) }}
      </h1>

      <p>{{ $t('home.privacyText', { name: siteData.legalName }) }}</p>
      <p>{{ $t('home.pageContent', { name: siteData.legalName }) }}</p>

      <privacy-form
        :from-site="fromSite"
        :mailchimp="siteData.mailchimp"
        :siteData="siteData"
        :locale="locale"
        @send="$_success"
        @error="$_fail"/>

  </div>
</template>

<script>
import asyncLoading from './mixins/asyncLoading'
import localeHandler from './mixins/localeHandler'
import PrivacyForm from '@/components/PrivacyForm'

export default {
  name: 'home',
  mixins: [ asyncLoading, localeHandler ],
  components: {
    PrivacyForm
  },
  methods: {
    $_success () {
      this.$router.push({ name: 'form-success', params: { fromSite: this.fromSite } })
    },
    $_fail (errors, info) {
      this.$router.push({ name: 'form-failure', params: { fromSite: this.fromSite } })
    }
  }
}
</script>

<style lang="scss">
.label_check .before {
  transition: all .4s ease-out;
}

.home-logo {
  text-align: center;
  max-width: 100%;
}

p {
  font-size: 19px; line-height: 1.4;
  color: #717171;
}

h1 {
  font-size: 37px !important;
  line-height: 1.1 !important;
  color: #313131;
  margin: 4rem 0 3.5rem !important;
}
</style>
